// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__F_2mt","tabs__wrapper":"style_tabs__wrapper__kOaqu","tabs__header":"style_tabs__header__ZsKGH","tabs__selection":"style_tabs__selection__KXmzy"};